export const base = 0
export const sticky = 1
export const toaster = 11
export const incomingCall = 20
export const tooltip = 30
export const modalBackground = 98
export const modal = 99
export const update = 99
export const errorToaster = 100
